<template lang="pug">
	.map-item(:class="data.className")
		.map-item_title(v-if="title") {{ title }}
		MapSVG(v-if="geodata",
			:geodata="geodata",
			:year="year",
			:width="data.width",
			:height="data.height",
			:initialScale="data.scale",
			:centerPoint="data.center",
			:zoomScale="data.zoomscale",
			:filters="filters",
			:responsive="data.responsive",
			:scaleMultiplier="data.scaleMultiplier",
			:parties="parties",
			:options="data.options",
			:isLive="isLive",
			:numInsets="numInsets",
			:selectedElectorate="selectedElectorate"
			@update:selectedElectorate="updateElectorate"
		)
</template>
<script>
import MapSVG from './MapSVG.vue';

export default {
  name: 'map-item',
  props: {
    data: {
      type: Object,
      required: true
    },
    filters: {
      type: Object
    },
    year: {},
    triggerLoad: {
      type: Boolean
    },
    triggerResultsLoad: {
      type: Boolean
    },
    numInsets: {},
    selectedElectorate: {}
  },
  computed: {
    title() {
      return this.data.title;
    },
    isLoading() {
      return this.$store.state.loading;
    },
    geodata() {
      return this.$store.getters.map(this.year);
    },
    parties() {
      return this.$store.getters.parties(this.year);
    },
    isLive() { return this.$store.getters.currentElection(this.year).live; },
  },
  methods: {
    updateElectorate(id) {
      this.$emit('update:selectedElectorate', id);
    }
  },
  components: { MapSVG },
  mounted() {
    // console.log(this.$el, this.triggerLoad, this.triggerResultsLoad)

    if (this.triggerLoad) {

      this.$store.dispatch('LOAD_MAP', {
        year: this.year,
        from: 'mapitem component'
      });
    }

    if (this.triggerResultsLoad) {
      this.$store.dispatch('LOAD_RESULTS', {
        year: this.year,
        from: 'mapitem component'
      });

    }
  }
};
</script>
<style lang="scss">
	@import "src/core/scss/global-sass";

	.map-item {

		&_title {
			@include font-title-xs;
			@include thaustalianFonts();
			padding-bottom: $m-spacing-x2;

			@include MQ_MobileOnly() {
				padding-bottom: $m-spacing;
			}
		}

		@include MQ_LargeOnly() {
			&_container {
				position: relative;
			}
		}

	}


</style>
